var map = {
	"./Login/foto_login.png": 1626,
	"./Login/img_login.png": 1627,
	"./campo_grafica.jpg": 1628,
	"./campo_indicaciones.png": 1629,
	"./campo_params.png": 1630,
	"./icons/feedback.png": 708,
	"./icons/feedback.svg": 709,
	"./icons/leak_blue.gif": 710,
	"./icons/leak_blue.png": 711,
	"./icons/leak_blue_old.png": 712,
	"./icons/leak_green.gif": 713,
	"./icons/leak_green.png": 714,
	"./icons/leak_green_old.png": 715,
	"./icons/leak_green_static.png": 716,
	"./icons/leak_red.gif": 717,
	"./icons/leak_red_anim.gif": 718,
	"./icons/leak_red_old.gif": 719,
	"./icons/leak_red_old.png": 720,
	"./icons/pin_blue.png": 721,
	"./icons/pin_green.png": 722,
	"./icons/pin_red.png": 723,
	"./icons/place.png": 724,
	"./icons/place.svg": 725,
	"./icons/place_blue.png": 726,
	"./icons/place_green.png": 727,
	"./icons/place_green.svg": 728,
	"./icons/place_red.gif": 729,
	"./icons/place_red.svg": 730,
	"./icons/place_red_old.png": 731,
	"./icons/place_yellow.png": 732,
	"./logos/GAES_SINGLE.png": 733,
	"./logos/GAES_VERTICAL.png": 734,
	"./logos/Logo_GAES.png": 319,
	"./logos/Logo_GAES_V.png": 169,
	"./logos/Logo_PIPE_EAGLE.png": 1631,
	"./logos/Logo_PIPE_EAGLE_V.png": 1632,
	"./logos/PIPE_EAGLE_SINGLE.png": 1633,
	"./logos/PIPE_EAGLE_VERTICAL.png": 1634,
	"./logos/favicon.png": 1635,
	"./logos/icon.ico": 1636,
	"./logos/logo_pemex_original.png": 320
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1809;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*$
// module id = 1809
// module chunks = 6